import React from "react";
import Table from "react-bootstrap/Table";
import { Row, Col } from "react-bootstrap";
import { DateToPersianNumber } from "../../../functions/index";
import Headings from "../../../constants/headings";
import Constants from "../../../constants/constants";
function UserActionHistory(props) {
  return (
    <>
      <h2>{Headings.ServiceUserActionHistoryHeading}</h2>
      <Row>
        <Col>
          <Table responsive className="roundedCorners">
            <thead>
              <tr>
                {props.heading.map((h, index) => (
                  <th key={index}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr className={props.data && props.data.length !== 0 ? "hide" : ""}>
                <td colSpan="3" className="center">{Constants.NoRecord}</td>
              </tr>
              {props.data &&
                props.data.map((d, index) => (
                  <tr key={index}>
                    <td>
                      {DateToPersianNumber(d.PersianActionDate)}  
                    </td>
                    <td>
                      {d.OperatorName}
                    </td>
                    <td>
                      {d.Description}
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </Col>
      </Row>
    </>
  );
}
export default UserActionHistory;
